export class User {
    constructor(public login:string , public password:string){}
}
